export default __webpack_public_path__ + "static/media/twitter.31f7ff0b.png";